import { axios } from '@/utils/request'

/**
 * 查询药品订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 15:21:29
 */
export function medicalorderPage (parameter) {
  return axios({
    url: '/buMedicalBooking/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 药品订单管理列表
 *
 * @author LIWEI
 * @date 2022-04-07 15:21:29
 */
export function medicalorderList (parameter) {
  return axios({
    url: '/medicalorder/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加药品订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 15:21:29
 */
export function medicalorderAdd (parameter) {
  return axios({
    url: '/medicalorder/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑药品订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 15:21:29
 */
export function medicalorderEdit (parameter) {
  return axios({
    url: '/medicalorder/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除药品订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 15:21:29
 */
export function medicalorderDelete (parameter) {
  return axios({
    url: '/medicalorder/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出药品订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 15:21:29
 */
export function medicalorderExport (parameter) {
  return axios({
    url: '/medicalorder/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}


/**
 * 获取药品订单详情
 *
 * @author LIWEI
 * @date 2022-04-12 15:21:29
 */
export function recipeDetial (parameter) {
  return axios({
    url: '/buMedicalBooking/pageProject',
    method: 'get',
    params: parameter,
  })
}